// 

    document.querySelectorAll('.num-control').forEach(control => {
      const input = control.querySelector('input');
      const btnUp = control.querySelector('.btnnum-up');
      const btnDown = control.querySelector('.btnnum-down');

      const step = parseFloat(control.dataset.step || 1);

      btnUp.addEventListener('click', () => {
        let val = parseFloat(input.value) || 0;
        let max = parseFloat(input.max);
        if (!isNaN(max)) val = Math.min(val + step, max);
        else val = val + step;
        input.value = val;
      });

      btnDown.addEventListener('click', () => {
        let val = parseFloat(input.value) || 0;
        let min = parseFloat(input.min);
        if (!isNaN(min)) val = Math.max(val - step, min);
        else val = val - step;
        input.value = val;
      });
    });


    document.querySelectorAll('.wpforms-field-number').forEach(input => {
    const wrapper = document.createElement('div');
    wrapper.className = 'wpforms-field-number-wrap';

    const minus = document.createElement('button');
    minus.innerText = ' ';
    minus.className = 'wpforms-number-btn btnDown';

    const plus = document.createElement('button');
    plus.innerText = ' ';
    plus.className = 'wpforms-number-btn btnUp';

    wrapper.appendChild(plus);
    wrapper.appendChild(minus);
    console.log(input);
    input.appendChild(wrapper);

    requestAnimationFrame(() => {
    	inputnum = input.querySelector('input');

	    minus.addEventListener('click', e => {
	        e.preventDefault();
	        const step = 1;
	        let val = parseFloat(inputnum.value) || 0;
	        let min = parseFloat(inputnum.min);
	        if (!isNaN(min)) val = Math.max(val - step, min);
	        else val = val - step;
	        if (val >= 0) {
	        inputnum.value = val;
	        inputnum.dispatchEvent(new Event('change'));
	        }
	    });

	    plus.addEventListener('click', e => {
	        e.preventDefault();
	        const step = 1;
	        let val = parseFloat(inputnum.value) || 0;
	        let max = parseFloat(inputnum.max);
	        if (!isNaN(max)) val = Math.min(val + step, max);
	        else val = val + step;
	        inputnum.value = val;
	        inputnum.dispatchEvent(new Event('change'));
	    });
	});
});
